/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Terminal (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgTerminal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m38 39 3 3-3 3m5 0h3m-11 5h14a2 2 0 0 0 2-2V36a2 2 0 0 0-2-2H35a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
    />
  </svg>
);
export default SvgTerminal;
